<ng-container *ngIf="data?.article">
  <div mat-dialog-title>
    <div class="df jsb ac f1">
      <h1>
        <T
          str="Request consent: {articleTitle}"
          [vars]="{
            articleTitle: data?.article.title ?? 'Unknown Article',
          }"></T>
      </h1>
      <button
        mat-icon-button
        (click)="dialogRef.close(null)">
        <mat-icon> clear</mat-icon>
      </button>
    </div>
  </div>
  <div mat-dialog-content>
    <div [innerHtml]="data.article.content"></div>
    <div *ngIf="data.requiresExplicitConsent === true">
      <mat-checkbox
        class="amt"
        [(ngModel)]="consentToArticle">
        <T str="I consent to the terms outlined in the article above."></T>
      </mat-checkbox>
    </div>
  </div>
  <div
    mat-dialog-actions
    class="df jfe ac">
    <div>
      <button
        mat-raised-button
        (click)="dialogRef.close({ consented: false })">
        <T str="Cancel"></T>
      </button>
    </div>
    <div>
      <button
        mat-raised-button
        color="primary"
        class="aml"
        [disabled]="requiresExplicitConsent && !consentToArticle"
        (click)="consent()">
        <T str="Consent"></T>
      </button>
    </div>
  </div>
</ng-container>
